import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { clearAuthSessionStorage } from 'core/storage/authSessionStorage';
import UserService from 'service/auth';

/**
 * Hook para manejar las acciones comunes del menú (returnPath y handleLogOut)
 */
export const useMenuActions = () => {
  const history = useHistory();
  const location = useLocation();

  const returnPath = useCallback(
    (path: string) => {
      const pathEvaluated = new RegExp(path);
      return location.pathname.search(pathEvaluated) !== -1;
    },
    [location.pathname],
  );

  const handleLogOut = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.preventDefault();
      if (window.location.pathname !== '/') {
        history.push('/');
      }
      clearAuthSessionStorage();
      UserService.doLogout();
    },
    [history],
  );

  return {
    returnPath,
    handleLogOut,
  };
};
